export const formTeamManagementNaming = {
    NEW_TEAM_MANAGEMENT_FORM: 'new-team-management-form',
};
